import { apiSlice } from './apiSlice';
// import { setDrawerFetchTime } from './authSlice';

const simpleApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getItems: builder.query({
      query: (data) => ({
        url: data?.url,
        method: 'GET',
        params: { ...data?.params },
      }),
      keepUnusedDataFor: 5,
      providesTags: (result, error, data) => [...data?.providesTags || []],
    }),
    getItemsLazy: builder.query({  // Новый lazy вариант
      query: (data) => ({ url: data?.url }),
      keepUnusedDataFor: 5,
      providesTags: (result, error, data) => [...data?.providesTags || []],
    }),
    getItemById: builder.query({
      query: (data) => ({
        url: data?.url,
        method: 'GET',
        params: { ...data?.params },
      }),
      keepUnusedDataFor: 5,
      providesTags: (result, error, data) => [...data?.providesTags || []],
    }),
    getItemByCode: builder.query({
      query: (data) => ({
        url: `${data?.url}/code/${data?.code}`,
      }),
      keepUnusedDataFor: 5,
      providesTags: (result, error, data) => [...data?.providesTags || []],
    }),
    createItem: builder.mutation({
      query: (data) => {
        const { url, invalidatesTags, body, ...rest } = data;
        const actualBody = body || rest;
        return {
          url: url,
          method: 'POST',
          body: actualBody,
        };
      },
      invalidatesTags: (result, error, data) => [...data?.invalidatesTags || []],
    }),
    updateItem: builder.mutation({
      query: (data) => {
        const { url, invalidatesTags, body, ...rest } = data;
        const actualBody = body || rest;
        return {
          url: url,
          method: 'PUT',
          body: actualBody,
        };
      },
      invalidatesTags: (result, error, data) => [...(data?.invalidatesTags || [])],
    }),
    deleteItem: builder.mutation({
      query: (data) => ({
        url: data?.url,
        // url: `${data?.url}/${data?.typeId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, data) => [...data?.invalidatesTags || []],
    }),
    getDataByCode: builder.query({
      query: ({ url, code, dateStart, dateEnd, settingsId, ...extra }) => ({
        url: `${url}/data/${code}`,  // /api/reports/data/ACQ_CLI
        params: {
          dateStart,
          dateEnd,
          settingsId,
          ...extra  // Другие параметры
        },
      }),
      providesTags: (result, error, arg) => [...(arg?.providesTags || ['Report'])],
    }),
    // getItems: builder.query({
    //   query: (data) => ({ url: data?.url }),
    //   keepUnusedDataFor: 5,
    //   providesTags: (result, error, data) => [...data?.providesTags || []],
    //   async onQueryStarted(arg, { dispatch, queryFulfilled }) {
    //     try {
    //       await queryFulfilled;  // Ждем успеха
    //       // dispatch(authApi.util.updateQueryData('getItems', arg, (draft) => {
    //       //   // Опционально: обновить data в кэше
    //       // }));
    //       dispatch(setDrawerFetchTime());  // Сохраняем время в Redux [web:36]
    //     } catch { }
    //   },
    // }),
  }),
});


export const {
  useLazyGetItemsQuery,  // Экспорт lazy хука
  useLazyGetDataByCodeQuery,
  useGetDataByCodeQuery,
  useGetItemsQuery,
  useGetItemByIdQuery,
  useGetItemByCodeQuery,
  useCreateItemMutation,
  useUpdateItemMutation,
  useDeleteItemMutation
} = simpleApiSlice;
